// 稀有度角标（EP-008-S4 / GDD 03 §②-2.3 / ⑧-C1~C4；R9 非颜色冗余通道）。
// 底部居中 1/2/3/4 圆点，色固定 var(--dot-color)（#3A2E28），不随档位变化。
// 只接 tier: number；不渲染任何 data-* 属性（ADR-005 §2.4）。
// aria-label/title 双通道含「档位名 + 点数」，仅数字视为失败。
import { RARITY_NAME_BY_TIER } from '../runtime/sequencer';

interface RarityDotsProps {
  tier: number; // 1..4
}

export function RarityDots({ tier }: RarityDotsProps) {
  const name = RARITY_NAME_BY_TIER[tier] ?? '普通';
  const label = `${name}，稀有度 ${tier}/4`;
  const dots = Array.from({ length: tier }, (_, i) => (
    <span key={i} className="rarity-dot" aria-hidden="true" />
  ));
  return (
    <div className="rarity-dots" role="img" aria-label={label} title={label}>
      {dots}
    </div>
  );
}
